const ChartMaximumIcon = () => {
    return(
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3" stroke="#30970B" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M6 6H6.00898M8.9982 6H9.00718M11.9964 6H12.0054M14.9946 6H15.0036M17.9928 6H18.0018M20.991 6H21" stroke="#30970B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19 21C19 14.3726 16.3137 9 13 9C9.68629 9 7 14.3726 7 21" stroke="#30970B" stroke-width="1.5" stroke-linejoin="round"/>
        </svg>
    )
}

export default ChartMaximumIcon